import { type ApiClientResponse, type EntityReferenceRailsRequestData, apiClient, routes } from 'common/services';
import type { VideoContentObjectDataObject } from 'models/service';

type CreateVideoRequestData = {
  video: {
    contentable_id: string;
    contentable_type: 'Organization';
    cover_photo?: EntityReferenceRailsRequestData;
    featured_in_channels: boolean;
    html_content: string;
    name: string;
    price_option: string;
    recorded_at: string;
    show_in_channels: boolean;
    tag_ids?: string[];
    text_content: string;
  };
};

export const createVideo = async (data: CreateVideoRequestData) =>
  apiClient.post<VideoContentObjectDataObject, ApiClientResponse<VideoContentObjectDataObject>>(
    routes.videos.create,
    data,
  );
